import styled, { keyframes } from 'styled-components';

const fadeIn = keyframes`
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
`;

const slideUp = keyframes`
  from {
    transform: translateY(50px);
    opacity: 0;
  }
  to {
    transform: translateY(0);
    opacity: 1;
  }
`;

export const ModalOverlay = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(0, 0, 0, 0.6);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 9999;
  animation: ${fadeIn} 0.2s ease-out;
  padding: 16px;

  @media (max-width: 768px) {
    padding: 0;
  }
`;

export const ModalContainer = styled.div`
  background: white;
  border-radius: 16px;
  width: 100%;
  max-width: 480px;
  height: 600px;
  display: flex;
  flex-direction: column;
  box-shadow: 0 8px 32px rgba(0, 0, 0, 0.2);
  animation: ${slideUp} 0.3s ease-out;
  overflow: hidden;

  @media (max-width: 768px) {
    max-width: 100%;
    height: 100vh;
    border-radius: 0;
  }
`;

export const ModalHeader = styled.div`
  background: linear-gradient(135deg, #4CAF50 0%, #45a049 100%);
  color: white;
  padding: 16px 20px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
`;

export const SellerInfo = styled.div`
  display: flex;
  align-items: center;
  gap: 12px;
  flex: 1;
  min-width: 0;

  @media (max-width: 480px) {
    gap: 8px;
  }

  .avatar {
    width: 44px;
    height: 44px;
    border-radius: 50%;
    background: rgba(255, 255, 255, 0.3);
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 18px;
    font-weight: 600;
    color: white;
    flex-shrink: 0;

    @media (max-width: 480px) {
      width: 38px;
      height: 38px;
      font-size: 16px;
    }
  }

  .info {
    display: flex;
    flex-direction: column;
    gap: 2px;
    min-width: 0;
    flex: 1;

    .name {
      font-size: 16px;
      font-weight: 600;
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;

      @media (max-width: 480px) {
        font-size: 14px;
      }
    }

    .ad-title {
      font-size: 12px;
      opacity: 0.9;
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;

      @media (max-width: 480px) {
        font-size: 11px;
      }
    }
  }
`;

export const CloseButton = styled.button`
  background: transparent;
  border: none;
  color: white;
  cursor: pointer;
  font-size: 20px;
  padding: 8px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 50%;
  transition: background 0.2s;
  flex-shrink: 0;
  width: 36px;
  height: 36px;

  &:hover {
    background: rgba(255, 255, 255, 0.2);
  }
`;

export const ModalBody = styled.div`
  flex: 1;
  overflow: hidden;
  background: #f0f2f5;
  background-image: 
    repeating-linear-gradient(
      45deg,
      transparent,
      transparent 10px,
      rgba(0, 0, 0, 0.02) 10px,
      rgba(0, 0, 0, 0.02) 20px
    );
`;

export const MessagesContainer = styled.div`
  height: 100%;
  overflow-y: auto;
  padding: 16px;
  display: flex;
  flex-direction: column;
  gap: 8px;

  @media (max-width: 768px) {
    padding: 12px;
  }

  @media (max-width: 480px) {
    padding: 8px;
  }

  /* Custom scrollbar */
  &::-webkit-scrollbar {
    width: 6px;
  }

  &::-webkit-scrollbar-track {
    background: transparent;
  }

  &::-webkit-scrollbar-thumb {
    background: rgba(0, 0, 0, 0.2);
    border-radius: 3px;
  }

  &::-webkit-scrollbar-thumb:hover {
    background: rgba(0, 0, 0, 0.3);
  }
`;

export const Message = styled.div`
  display: flex;
  flex-direction: column;
  align-items: ${props => props.fromMe ? 'flex-end' : 'flex-start'};
  max-width: 75%;
  align-self: ${props => props.fromMe ? 'flex-end' : 'flex-start'};
  animation: ${slideUp} 0.2s ease-out;

  @media (max-width: 768px) {
    max-width: 85%;
  }

  @media (max-width: 480px) {
    max-width: 90%;
  }

  .message-content {
    background: ${props => props.fromMe ? '#4CAF50' : '#ffffff'};
    color: ${props => props.fromMe ? '#ffffff' : '#000000'};
    padding: 10px 14px;
    border-radius: 12px;
    border-top-right-radius: ${props => props.fromMe ? '4px' : '12px'};
    border-top-left-radius: ${props => props.fromMe ? '12px' : '4px'};
    word-wrap: break-word;
    box-shadow: 0 1px 2px rgba(0, 0, 0, 0.1);
    font-size: 14px;
    line-height: 1.4;

    @media (max-width: 480px) {
      padding: 8px 12px;
      font-size: 13px;
    }
  }

  .message-time {
    font-size: 11px;
    color: #667781;
    margin-top: 4px;
    padding: 0 6px;
  }
`;

export const EmptyState = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  height: 100%;
  color: #667781;
  gap: 12px;

  i {
    font-size: 48px;
    opacity: 0.3;
  }

  p {
    font-size: 16px;
    font-weight: 500;
    margin: 0;
  }

  small {
    font-size: 13px;
    opacity: 0.7;
  }
`;

export const ModalFooter = styled.div`
  background: white;
  padding: 12px 16px;
  border-top: 1px solid #e9edef;
`;

export const MessageInput = styled.input`
  flex: 1;
  padding: 12px 16px;
  border: none;
  border-radius: 24px;
  background: #f0f2f5;
  font-size: 15px;
  outline: none;
  transition: background 0.2s;

  &:focus {
    background: #e9edef;
  }

  &::placeholder {
    color: #8696a0;
  }

  &:disabled {
    opacity: 0.6;
    cursor: not-allowed;
  }
`;

export const SendButton = styled.button`
  width: 44px;
  height: 44px;
  border-radius: 50%;
  border: none;
  background: ${props => props.disabled ? '#ccc' : '#4CAF50'};
  color: white;
  cursor: ${props => props.disabled ? 'not-allowed' : 'pointer'};
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 16px;
  transition: all 0.2s;
  flex-shrink: 0;

  &:hover:not(:disabled) {
    background: #45a049;
    transform: scale(1.05);
  }

  &:active:not(:disabled) {
    transform: scale(0.95);
  }

  i {
    transition: transform 0.2s;
  }

  &:hover:not(:disabled) i {
    transform: translateX(2px);
  }
`;

export const TypingIndicator = styled.div`
  display: flex;
  align-items: center;
  gap: 4px;
  padding: 10px 14px;
  background: #ffffff;
  border-radius: 12px;
  border-top-left-radius: 4px;
  width: fit-content;
  box-shadow: 0 1px 2px rgba(0, 0, 0, 0.1);

  span {
    width: 8px;
    height: 8px;
    border-radius: 50%;
    background: #90949c;
    animation: typing 1.4s infinite;

    &:nth-child(2) {
      animation-delay: 0.2s;
    }

    &:nth-child(3) {
      animation-delay: 0.4s;
    }
  }

  @keyframes typing {
    0%, 60%, 100% {
      transform: translateY(0);
      opacity: 0.7;
    }
    30% {
      transform: translateY(-10px);
      opacity: 1;
    }
  }
`;

export const OfferButton = styled.button`
  padding: 10px;
  background-color: #FF9800;
  color: white;
  border: none;
  border-radius: 8px;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: all 0.2s;
  font-size: 16px;

  &:hover {
    background-color: #F57C00;
    transform: scale(1.05);
  }

  &:active {
    transform: scale(0.95);
  }
`;

export const OfferModal = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(0, 0, 0, 0.5);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 10000;
  padding: 16px;
  animation: ${fadeIn} 0.2s ease-out;
`;

export const OfferCard = styled.div`
  background: ${props => 
    props.status === 'accepted' ? '#d4edda' :
    props.status === 'rejected' ? '#f8d7da' :
    props.status === 'pending' ? '#fff3cd' :
    props.status === 'countered' ? '#d1ecf1' :
    '#f5f5f5'
  };
  padding: 12px;
  border-radius: 8px;
  margin-bottom: 8px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  border: 1px solid ${props => 
    props.status === 'accepted' ? '#c3e6cb' :
    props.status === 'rejected' ? '#f5c6cb' :
    props.status === 'pending' ? '#ffeeba' :
    props.status === 'countered' ? '#bee5eb' :
    '#ddd'
  };
`;

export const QuickReplyContainer = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
  padding: 12px 16px;
  background: white;
  border-top: 1px solid #e9edef;
  max-height: 120px;
  overflow-y: auto;
`;

export const QuickReplyButton = styled.button`
  padding: 8px 14px;
  background: #f0f2f5;
  border: 1px solid #e9edef;
  border-radius: 16px;
  font-size: 13px;
  color: #333;
  cursor: pointer;
  transition: all 0.2s;
  white-space: nowrap;

  &:hover {
    background: #e9edef;
    border-color: #667eea;
    color: #667eea;
  }

  &:active {
    transform: scale(0.95);
  }
`;
